import { earningsHeadlineLevels, emptyValue } from './constants'

export const formatEarningsAmount = (amount, currency, language, fractionDigits = 0) => {
  if (amount === null) return emptyValue

  return new Intl.NumberFormat(language, {
    style: 'currency',
    currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    signDisplay: 'negative',
  }).format(Number(amount))
}

export const formatEarningsPercentage = (percentage, language) => {
  if (percentage === null) return emptyValue

  return new Intl.NumberFormat(language, {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(percentage) / 100)
}

export const getEarningsHeadline = earnings => {
  if (earnings.has_missing_logistics_or_customs) {
    return {
      level: earningsHeadlineLevels.product,
      percentage: earnings.product_margin_percentage,
      amount: earnings.product_margin,
    }
  }

  return {
    level: earningsHeadlineLevels.operating,
    percentage: earnings.operating_margin_percentage,
    amount: earnings.operating_margin,
  }
}
